import { all, takeEvery, call, put } from 'redux-saga/effects';
import actions from './actions';
import Api from '../../../../helpers/api';
import { sendRequest } from '../../../../helpers/saga';
import { logger } from '../../../../helpers/logger';
import notifications from '../../../../redux/notifications/actions';
import { createSearchParams } from '../utils';

const sessionListPastApi = new Api('orientations/past');
const groupSessionListPastApi = new Api('orientations/:id/sessions/past');

function* loadSessionsPast(data) {
  try {
    const { page = 1, pageSize = 10, column, order, filter } = data.payload;
    const defaultSearchParams = { page, per_page: pageSize, column, order };
    const searchParams = createSearchParams({
      defaultSearchParams,
      filter,
      tab: 'past',
    });

    const result = yield call(
      sendRequest,
      sessionListPastApi.load,
      { search: searchParams },
      notifications.REQUEST_ERROR,
    );

    if (result.data.success) {
      const {
        data: {
          success: { data: sessions },
        },
      } = result;
      yield put(actions.loadSessionsPastSuccess(sessions));
    }
  } catch (error) {
    logger.error(error);
  }
}

function* loadGroupSessionsPast(data) {
  try {
    const { page = 1, pageSize = 10, column, order, filter, recurrenceSessionId } = data.payload;
    const defaultSearchParams = { page, per_page: pageSize, column, order };
    const searchParams = createSearchParams({
      defaultSearchParams,
      filter,
      tab: 'past',
    });

    const result = yield call(
      sendRequest,
      groupSessionListPastApi.load,
      { id: recurrenceSessionId, search: searchParams },
      notifications.REQUEST_ERROR,
    );

    if (result.data.success) {
      const {
        data: {
          success: { data: sessions },
        },
      } = result;
      yield put(actions.loadGroupSessionsPastSuccess(sessions));
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD_REQUEST, loadSessionsPast)]);
  yield all([takeEvery(actions.LOAD_GROUP_REQUEST, loadGroupSessionsPast)]);
}
